import React, { useState, useEffect } from 'react'
import { MultiSelect } from 'primereact/multiselect';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { statusDisponibles } from '../../ComponentsCat/Constantes/constantes';
import { TextoAdvertencia, MensajeAdvertencia } from '../../ComponentsCat/Mensajes/Mensajes';
import useBotones from '../../../../components/hooks/useBotones';
import { PLANTAS_GET_COMBO, ROLES } from '../../../../genericos/Uris';

import { Service } from '../../../../service/Service';
import Environment from '../../../../Environment';
import Spinner from '../../../../components/loader/Spinner';
const getRoute = Environment()

const CrearModificar = ({
    productDialog,
    titulos,
    hideDialog,
    product,
    updateField,
    saveProduct,
    tieneId,
    estiloAP, setEstiloAP,
    estiloAM, setEstiloAM,
    estiloNombre, setEstiloNombre, loadingModal, setLoadingModal,
}) => {
    const rolService = new Service()
    //--------------------| Dropdown  |--------------------
    //--> Consumir roles
    const [listaRoles, setListaRoles] = useState([])
    useEffect(() => {
        const consultarRoles = async () => {
            rolService.baseUrl = `${getRoute}/${ROLES}`
            try {
                setLoadingModal(true)
                const res = await rolService.readAll()
                // console.log(res)
                setListaRoles(res)
            } catch (error) { console.log(error) }
            finally { setLoadingModal(false) }
        }
        consultarRoles()
    }, [product.idRol])

    //--------------------| Validar campos  |--------------------
    const [datosInvalidos, setDatosInvalidos] = useState(false)     // Validar envio
    const [campoInvalido, setCampoInvalido] = useState(false)
    const [mensaje, setMensaje] = useState("")                      // Mensaje para envio
    const [texto, setTexto] = useState("")                          // Mensaje para input
    const expresion = /^([a-zA-Z\sÁÉÍÓÚáéíóúÑñ]+)$/                   // Acentos y letra 'ñ'
    //--> Validar input
    const ValidarNombre = (texto) => {
        if (!expresion.test(texto)) {
            setEstiloNombre("p-invalid")
            setTexto("Campo invalido")
            setCampoInvalido(true)
        } else {
            setEstiloNombre("")
            setTexto("")
            setCampoInvalido(false)
        }
    }
    const ValidarAP = (texto) => {
        if (!expresion.test(texto)) {
            setEstiloAP("p-invalid")
            setTexto("Campo invalido")
            setCampoInvalido(true)
        } else {
            setEstiloAP("")
            setTexto("")
            setCampoInvalido(false)
        }
    }
    const ValidarAM = (texto) => {
        if (!expresion.test(texto)) {
            setEstiloAM("p-invalid")
            setTexto("Campo invalido")
            setCampoInvalido(true)
        } else {
            setEstiloAM("")
            setTexto("")
            setCampoInvalido(false)
        }
    }

    const enviarDatos = () => {
        if (Object.values(product).includes("")) {
            setMensaje("Todos los campos son obligatorios")
            setDatosInvalidos(true)
            setTimeout(() => { setDatosInvalidos(false) }, 3000)
            return
        }
        else {
            if (campoInvalido) {
                setMensaje("Algún campo no es valido")
                setDatosInvalidos(true)
                setTimeout(() => { setDatosInvalidos(false) }, 3000)
                return
            }
        }
        saveProduct()
    }
    //--> Accion de botones
    const [botones] = useBotones(
        "Cancelar", "pi pi-times", "p-button-rounded", hideDialog,
        "Guardar", "pi pi-check", "p-button-rounded", enviarDatos
    )

    //--------------------| Valor que regresara  |--------------------
    return (
        <Dialog
            visible={productDialog} onHide={hideDialog}
            footer={!loadingModal && botones} header={titulos.VentanaCrear}
            style={{ width: '450px' }} modal className="p-fluid"
        >
            {loadingModal && (<Spinner />)}
            {!loadingModal && (

                <>
                    <div className="field">
                        <label>Rol</label>
                        <Dropdown
                            value={product.idRol} onChange={(e) => updateField(e.value, "idRol")}
                            options={listaRoles} optionLabel="nombre" optionValue="id"
                            placeholder="Selecciona un rol" />
                    </div>
                    {!tieneId && (<div className="field">
                        <label>Status</label>
                        <Dropdown
                            value={product.idEstatus}
                            options={statusDisponibles} onChange={e => updateField(e.value, "idEstatus")}
                            optionLabel="status" placeholder="--Selecciona un status--"
                        />
                    </div>)}
                    <div className="field">
                        <label htmlFor="nombre">Nombre</label>
                        <InputText
                            id="nombre"
                            value={product.nombre}
                            onChange={(e) => {
                                updateField(e.target.value, "nombre")
                                ValidarNombre(e.target.value)
                            }}
                            required autoFocus className={estiloNombre} maxLength="10" />
                        {estiloNombre && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                    </div>
                    <div className="field">
                        <label htmlFor="apellidos">Apellidos</label>
                        <InputText
                            id="apellidos"
                            value={product.apellidos}
                            onChange={(e) => {
                                updateField(e.target.value, "apellidos")
                                ValidarAP(e.target.value)
                            }}
                            required autoFocus className={estiloAP} maxLength="35" />
                        {estiloAP && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                    </div>
                    <div className="field">
                        <label htmlFor="email">Email</label>
                        <InputText
                            id="email"
                            value={product.email}
                            onChange={(e) => { updateField(e.target.value, "email") }}
                            required autoFocus maxLength="100" />
                    </div>
                    {tieneId?
                        <div className="field">
                            <label htmlFor="usuario">Usuario</label>
                            <InputText
                                id="usuario"
                                value={product.usuario}
                                onChange={(e) => {
                                    updateField(e.target.value, "usuario")
                                }}
                                required autoFocus maxLength="12" />
                        </div>:
                        <div className="field">
                            <label htmlFor="usuario">Usuario</label>
                            <InputText
                                id="usuario"
                                disabled
                                value={product.usuario}
                                onChange={(e) => {
                                    updateField(e.target.value, "usuario")
                                }}
                                required autoFocus maxLength="12" />
                        </div>
                    }
                    {datosInvalidos && <MensajeAdvertencia>{mensaje}</MensajeAdvertencia>}
                </>
            )}
        </Dialog>
    )
}

export default CrearModificar
